import React, { useState } from "react";
import { DryLabItems } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import GoToTop from "./GoToTop";

function DropdownD() {
  const [dropdownD, setDropdownD] = useState(false);

  return (
    <>
      <ul
        className={dropdownD ? "submenu clicked" : "submenu"}
        onClick={() => setDropdownD(!dropdownD)}
      >
        {DryLabItems.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => {setDropdownD(false);GoToTop()}}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownD;
